import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OccurrenceForm.html?raw';
import OccurrencePropertiesTable from '../OccurrencePropertiesTable/OccurrencePropertiesTable';
import "../OccurrencePropertiesTable/OccurrencePropertiesTable";

import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";

import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import "../../../moreCore/UI/DateTimeInput/DateTimeInput";
import "../../../moreCore/UI/DateTimeInput/DateTimeInput";
import Edit from '../../../moreCore/UI/Edit/Edit';
import "../../../moreCore/UI/Edit/Edit";
import domClass from 'dojo/dom-class';
import MultiselectBox from '../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import { FeatureHelpers, ToasterHelpers, TranslationHelpers, UrlHelpers } from "../../../more/Helpers";
import _uiFrameMixin from '../../../moreCore/UI/Container/uiFrame';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

class OccurrenceForm extends compose(_uiFrameMixin) {
    templateString: any = template;

    private inputOccurrenceTypeContainer: HTMLElement;
    private propertiesContainer: HTMLElement;
    private txtOccurrenceType: HTMLElement;
    private txtOccurrenceTitle: HTMLElement;
    private iconContainerDraft: HTMLElement;
    private sectionTitle: HTMLElement;
    private sectionType: HTMLElement;
    private sectionTypeHeading: HTMLElement;
    private sectionProperties: HTMLElement;
    private sectionSpecialInfo: HTMLElement;
    private sectionTicketInfo: HTMLElement;
    private sectionComment: HTMLElement;
    private sectionCoeditors: HTMLElement;
    private commentContainer: HTMLElement;
    private tableSpecialNote: HTMLTableElement;
    private txtSpecialNote: HTMLTableCellElement;
    private buttonCheckSpecialConfirmation_Unchecked: HTMLTableCellElement;
    private buttonCheckSpecialConfirmation_Checked: HTMLTableCellElement;
    private txtSpecialConfirmation: HTMLTableCellElement;
    private tableSpecialConfirmation: HTMLTableElement;
    private inputOccurrenceTitle: MdsLax<InstanceType<typeof Edit>>;
    private inputComment: HTMLTextAreaElement;
    private inputOccurrenceType: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputDateTime: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputReporter: MdsLax<InstanceType<typeof Edit>>;
    private inputCoeditors: MdsLax<InstanceType<typeof MultiselectBox>>;
    private propertiesTable: MdsLax<InstanceType<typeof OccurrencePropertiesTable>>;

    entityID: string = null;

    private entity: Occurrence.OccurenceEntity = null; // Entity wies aus der Datenbank kommt
    private continuousSaveMode: boolean = false; // wenn true werden Datenänderungen immer gleich in die Datenbank zurückgespielt
    isDirty: boolean = false;
    isDraft: boolean = false;
    private _formDataUndirty: string | Occurrence.OccurrenceDialogFormData = null;

    private startupState: "new" | "ready" | "loading" = "new";

    private errorCallback: Function = null;
    private successCallback: Function = null;

    private readonly: boolean = false;
    private locked: boolean = false;

    isSpecialConfirmationNeeded: boolean;
    _specialConfirmationStatus: boolean;


    // Objekt mit Werten die beim Speichern übergeben werden (live / immer aktuell)
    formData: Occurrence.OccurrenceDialogFormData = {
        occurrenceTypeID: null,
        entityID: null,
        comment: null,
        title: null,
        coeditors: null,
        properties: null, // neue Tabelle ab 2021!!
        //_propertyAttributeHelper: "value_text_global" // temporär! wir müssen von value_text auf _global umschalten und die API kennt sich sonst nicht aus...
    };

  
    postCreate() {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;

        let config = FeatureHelpers.getModule<{ lockLeaseSeconds: number }>("eforms");


        if (config) {
            if (config.lockLeaseSeconds >= 60) {
                this._lockLeaseTimeSec = config.lockLeaseSeconds;
            }
        }

        on(this.propertiesTable, "change", lang.hitch(this, this._onChangeProperties));
        on(this.propertiesTable, "requestOccurrenceForm", lang.hitch(this, this._onRequestOccurrenceForm));


    }
    private _occurrenceEntityRequest: dojo.request.Promise<any> = null;
    private _loadOccurrenceEntity(): void {

        if (!this.entityID) return;

        this.startupState = "loading";


        if (this._occurrenceEntityRequest != null) {
            this._occurrenceEntityRequest.cancel();
        }


        this._occurrenceEntityRequest = this.RequestManager.callfunction(
            "Webtool_Occurrence_API__LoadOccurrenceJSON",
            { occurrenceID: this.entityID },
            lang.hitch(this, this._onLoadOccurrenceEntityResult),
            lang.hitch(this, this._onLoadOccurrenceEntityError)
        );
    }

    private _onLoadOccurrenceEntityError(error: more.requestErrorMessage) {
        this.StandbyStop();
        this._occurrenceEntityRequest = null;
        alert(error.Message);
    }

    private _onLoadOccurrenceEntityResult(response: Occurrence.OccurenceEntity): void {
        this._occurrenceEntityRequest = null;

        this.setFormData(response);

        this.StandbyStop();

        this.emit("loaded", response);
    }

    startup() {
        super.startup.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";


        //this.inputOccurrenceType.loadListValues();

        if (!this.entity && !this.entityID) {
            let createVal = UrlHelpers.getUrlParameterValue("ctype");
            if (createVal) {
                this.inputOccurrenceType.setValue(createVal, false);
            }
        }

        UrlHelpers.removeUrlParameter("ctype");

        if (this.entityID && !this.entity) {
            //this._loadOccurrenceEntity(); // macht onfirstStartup
        }
        else {
            domClass.remove(this.sectionComment, "w3-hide");

            
        }

        if (this.hasFeature("eForms/coEditor")) {
            this.setupCoeditors();
        }
    }
    onClose() {
        this._removeTimeouts();
    }

    onFirstStartup() {
        if (this.entityID && !this.entity && !this._occurrenceEntityRequest) {
            this.inputOccurrenceTitle.setReadonly(true);
            this.inputOccurrenceTitle.setMandatory(false);

            this._loadOccurrenceEntity();
        }

        this.UiModder.domClass.toggle(this.domNode, "section", this.isEmbeddedInTab);
        this.addButtonEx({
            internalName: "submit",
            label: "OccurrenceFormDialog__submitBtnLabel",
            enabled: false,
            bCloseOnClick: false,
            callback: lang.hitch(this, this._onClickSubmitOccurrenceButton, false),
            iconClass: "fas fa-save",
            styleClass: "primaryBG",
            position: "primary",
            order: 1
        });


        if (this.hasFeature("eForms/draft")) {
            this.addButtonEx({
                internalName: "draft",
                label: "OccurrenceFormDialog__submitDraftBtnLabel",
                callback: lang.hitch(this, this._onClickSubmitOccurrenceButton, true),
                styleClass: "secondaryBG",
                iconClass: "fas fa-pencil-ruler",
                enabled: false,
                bCloseOnClick: false,
                position: "primary",
                additionalPosition: "primary",
                order: 2 // an die zweite Stelle (also effektiv links neben Speichern) setzen
            });
        }

    }

    private setupCoeditors(): void {
        this.inputCoeditors.valueAttribute = "ID";
        this.inputCoeditors.labelAttribute = "gDisp_Firstname_Name";

        let coeditorsRequestData = {
            "occurrenceID": null
        };

        if (this.entityID) {
            coeditorsRequestData.occurrenceID = this.entityID // achtung, es könnte auch die web-guid sein...
        }

        this.RequestManager.callfunction(
            "Webtool_Occurrence_API__LoadCoeditors",
            coeditorsRequestData,
            lang.hitch(this, this._onLoadCoeditors),
            lang.hitch(this, this._onLoadCoeditorsError)
        );
    }

    private _onLoadCoeditors(response: { availableList: Array<{ ID: string, gDisp_1: string, gDisp_Firstname_Name: string}>, selectedIds: Array<string>, unselectableIds : Array<string> }) {
        //console.debug("_onLoadCoeditors", response);
        //this.inputCoeditors.setData(response.selectedIds, response.availableList, true);
        this.inputCoeditors.setOptionsEx({
            labels: response.availableList.map(entry => entry.gDisp_Firstname_Name),
            values: response.availableList.map(entry => entry.ID),
            entityData: response.availableList,
            presetValue: response.selectedIds,
            selectable: response.availableList.map(entry => response.unselectableIds .indexOf(entry.ID) == -1 && entry.ID != window.sessionInfo.getCurrentEmployeeId())
        }, true)

        domClass.remove(this.sectionCoeditors, "w3-hide");

    }

    private _onLoadCoeditorsError(error: more.requestErrorMessage) {
        console.error(this.id + " _onLoadCoeditorsError", error.Message);
    }

    setReadonly(value: boolean): void {
        if (value != true && value != false) {
            value = this.readonly;
        }
        this.readonly = value;

        // Reporter editierbar?

        let occurrenceType: Occurrence.OccurrenceType = null;
        if (this.entity != null) {
            occurrenceType = this.entity.ref_occurrence_type;
        }

        this.disableNode(this.inputComment, this.readonly);
        //this.UiModder.domClass.toggle(this.sectionProperties, "noInteraction", this.readonly);
        if (this.propertiesTable) this.propertiesTable.setReadOnly(value);

        //  Meldungsart
        //
        if (this.inputOccurrenceType != null) {
            this.inputOccurrenceType.setReadonly(this.readonly || this.entity != null);
        }

        this.inputOccurrenceTitle.setReadonly(this.readonly === true);
        this.inputCoeditors.setReadonly(this.readonly === true);

        //  implement readonly for the table

    }

    

    private _serializeDataHandle: any = null;
    private serializeData_delayed(resetDirtyState?: boolean, bypassReadonly?: boolean, delay?: number): void {
        if (this._serializeDataHandle != null) {
            clearTimeout(this._serializeDataHandle);
            this._serializeDataHandle = null;
        }

        if (!delay || delay < 0) delay = 200;

        this._serializeDataHandle = setTimeout(lang.hitch(this, this.serializeData, resetDirtyState, bypassReadonly), delay);
    }

    private serializeData(resetDirtyState?: boolean, bypassReadonly?: boolean): void {
        //console.debug("occurrenceForm serializeData (state - reset?)", this.startupState, resetDirtyState);
        if (this._serializeDataHandle != null) {
            clearTimeout(this._serializeDataHandle);
            this._serializeDataHandle = null;
        }
        //dateOfRecord wird einmal direkt gesetzt und kann/darf sich nicht ändern
        //selbiges für reporterID - UPDATE: Reporter ist änderbar

        let entity: Occurrence.OccurrenceType = this.inputOccurrenceType.get("selectedEntity");
        this.formData.occurrenceTypeID = (entity != null ? entity.ID : null);

        this.formData.coeditors = this.inputCoeditors.getValue();

        this.formData.title = this.inputOccurrenceTitle.getValue();

        //this.formData.propertyData = (this.propertyTable != null ? this.propertyTable.getData() : null);
        this.formData.properties = this.propertiesTable._jsonDataOut;

        //if (this.hasUserRole("_DEV")) {
        //    if (this.propertiesTable.isValid != true) {
        //        this.showToast({
        //            title: "DEV: properties invalid",
        //            ID: "invalidProps",
        //            timeout: 2000,
        //            iconClass: "fas fa-times w3-text-red"
        //        });
        //    } else {
        //        this.showToast({
        //            title: "DEV: properties valid",
        //            ID: "invalidProps",
        //            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        //        });
        //    }
        //}

        this.formData.comment = this.inputComment.value;

        let dirtyFormDataStr = JSON.stringify(this.formData);

        if (resetDirtyState === true) {
            this._formDataUndirty = dirtyFormDataStr;
        }

        if (this.readonly == true && bypassReadonly !== true) { // nicht weitermachen wenns schreibgeschützt ist!
            return;
        }

        if (this.startupState != "ready") return;

        if (this._formDataUndirty) {
            this.setDirty(this._formDataUndirty != dirtyFormDataStr);

        } else {
            this.setDirty(!this._formDataUndirty == null && this.formData != null);
        }

        //console.debug("occurrenceForm serialized Data (state - reset? - dirty?)", this.startupState, resetDirtyState, this.isDirty);



        //    if (this.isDirty === true && this.continuousSaveMode === true && this.startupState == "ready") {
        //        this.saveOccurrenceData();
        //    }
    }

    checkMandatoryValues(scrollIntoView?: boolean): boolean {

        if (!this.inputOccurrenceType.getValue()) {
            return false;
        }

        if (!this.propertiesTable.isValid) {
            // zur fehlenden Eigenschaft wechseln...?
            if (scrollIntoView === true) {
                this.propertiesTable.checkMandatory(null, scrollIntoView);
            }
            return false;
        }

        return true;

    }

    getEntity(): Occurrence.OccurenceEntity {
        return this.entity;
    }

    private _submitInProgess: boolean = false;

    saveOccurrenceData(saveAsDraft?: boolean): void {

        let bQuitDraft = this.isDraft == true && saveAsDraft !== true;

        // gerade kein Speicherprozess
        // und es muss entweder dirty sein, oder es muss von Entwurf auf Nicht-Entwurf geändert werden
        if (this._submitInProgess !== true && (this.isDirty == true || bQuitDraft)) {

        } else {
            return;
        }

        if (this.isSpecialConfirmationNeeded === true && this._specialConfirmationStatus != true) {
            this.showToast({

                title: this.translations["OccurrenceForm__message_specialConfirmationNeeded"],
                timeout: 15000,
                iconClass: ToasterHelpers.ToasterIcons.warning
            });
            return;
        }

        if (this.checkMandatoryValues(!saveAsDraft) === true) {

        } else {
            if (!saveAsDraft) {
               
                return;
            }
        }

        this._submitInProgess = true;

        this.emit("saving");


        this.StandbyStart();


        //console.log("saveOccurrenceData", this.formData);
        this.formData.saveAsDraft = saveAsDraft === true;
        this.formData.entityID = this.entityID;

        
        this.RequestManager.callfunction(
            "Webtool_Occurrence_API__SaveOccurrence",
            this.formData,
            lang.hitch(this, this._onSaveOccurrenceDataResponse),
            lang.hitch(this, this._onSaveOccurrenceDataError),
            true
        );
    }

    private _onSaveOccurrenceDataResponse(response: any): void {

        //this.serializeData(true); // sinnlos, weil laden hinterher eh alles wieder zunichte oder selber macht
        this._submitInProgess = false;
        this._formDataUndirty = this.formData;


        this.showToast({
            title: "OccurrenceForm__SaveSuccess",
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck,
            ID: "saveResult",
            showClose: false
        });
        
        this.emit("saved");

        UrlHelpers.removeUrlParameter("create");
        UrlHelpers.removeUrlParameter("ctype");


        this.entityID = response.GUID;

        this._loadOccurrenceEntity(); // unbedingt neu laden, weil in Gruppen temporäre GUIDs ersetzt worden sind nach Speichern!

    }

    private _onSaveOccurrenceDataError(error: more.requestErrorMessage): void {
        let exception: boolean = true;
        if (this.continuousSaveMode != true) {
            this.StandbyStop();
            this.handleErrorResponse(error.Message);

        }
        this._submitInProgess = false;
        // auch bei live-Speicherung den Benutzer informieren?
    }


    setFormData(occurrenceEntity: Occurrence.OccurenceEntity): void {

        if (occurrenceEntity) this.entity = occurrenceEntity;
        if (!this.entity) return;

        this.hideNode(this.sectionType);
        this.hideNode(this.sectionTypeHeading, false);

        this.txtOccurrenceTitle.innerHTML = this.entity.title
        this.txtOccurrenceType.innerHTML = this.entity.ref_occurrence_type.description;
        if (this.entity.ref_occurrence_type.coloration?.BackColor?.IsNull != true) {
            this.colorNode(this.sectionTypeHeading, this.entity.ref_occurrence_type.coloration);
        }


        this.startupState = "loading";

        this.entityID = this.entity.ID;

        UrlHelpers.removeUrlParameter("ctype");
        UrlHelpers.removeUrlParameter("create");
        if (UrlHelpers.getUrlParameterValue("view") == false) UrlHelpers.setUrlParameter("view", this.entity.ID);

        this.setTitles(this.entity.title);

        this.isDraft = this.entity.isDraft;
        this.hideNode(this.iconContainerDraft, !this.isDraft);

        if (!this.isDraft) {
            this.removeButton("draft");
        }

        //console.log("occurenform set data: ", this.jsonEntity)

        this.setReadonly(this.entity.isReadonly || this.locked);
        

        this._checkEntityLock();

        this._renderPropertiesTable(this.entity.EL_ht_occurrence_property_occurrence);

        this.inputComment.value = this.entity.note;
        this.inputCoeditors.setValue(this.entity.coeditors, true);

        this.inputOccurrenceTitle.setValue(this.entity.title);

        this.inputOccurrenceType.setValue(this.entity.ref_occurrence_type, true);

        this.setSpecialInfoByOccurrenceType(this.entity.ref_occurrence_type);

        this.inputReporter.setValue(this.entity.ref_reporter.gDisp_1);
        this.inputDateTime.setValue(this.entity.reported_date);
        this.inputDateTime.setReadonly(true);

        this.UiModder.domClass.remove(this.sectionTicketInfo, "w3-hide");

        this.serializeData(true);

        this.setDirty(false); // es ist so: das serializedata führt zu setdirty, aber NUR wenn startupstate auf ready steht.
        // den schalten wir aber erst später auf ready, damit die Properties etc Zeit haben, zu serialisieren und ihr change-event zu feuern und unser undirty-state stimmt.
        // wir möchten aber dennoch den submitbutton aktiv schalten, wenn es readonly und lock und draft zulassen. das setdirty kümmert sich drum

        setTimeout(lang.hitch(this, function () { this.startupState = "ready"; }), 650);
    }



    loadPropertyList(): void {

        this.UiModder.domClass.remove(this.sectionProperties, "w3-hide");



        let url: string = window.appRoot + "Eforms/LoadOccurrencePropertiesJSON";

        let data = null;

        // bei einer neuen Meldung muss die Liste aus dem angegebenen Meldungstyp geladen werden
        if (this.entityID == null) {
            if (!this.formData.occurrenceTypeID) {
                this._renderPropertiesTable(null);
                return;
            }
            data = { occurrenceTypeID: this.formData.occurrenceTypeID };
        }
        // bei einer bestehenden Meldung kommt die Liste direkt aus der Meldung
        else {
            data = { occurrenceID: this.entityID };
        }
        this.StandbyStart(this.sectionProperties);

        this.RequestManager.callfunction(
            "Webtool_Occurrence_API__GetPropertyListJSON",
            data,
            lang.hitch(this, this._onLoadPropertyListResponse),
            lang.hitch(this, this._onLoadPropertyListError),
        );
    }

    private _onLoadPropertyListResponse(response): void {

        this.StandbyStop();
        let entitylist: Array<Occurrence.PropertyAssignment> = response;

        this._renderPropertiesTable(entitylist);

    }
    private _onChangeOccurenceTitle() {
        this.serializeData_delayed(this.startupState != "ready", null, 50);

        let title = this.inputOccurrenceTitle.getValue();
        let occTypeEntity: Occurrence.OccurrenceType = this.inputOccurrenceType.getValue(true);

        if (!this.entity) {
            if (title || occTypeEntity) {
                this.setTitles(TranslationHelpers.translate("General_New") + (title ? " - " + title : occTypeEntity ? " - " + occTypeEntity.description : ""));
            }
        }
    }

    private _onRequestOccurrenceForm(targetID: string) {
        this.emit("requestOccurrenceForm", targetID);
    }

    private _onChangeProperties(data): void {
        //console.debug("_onChangeProperties", this.startupState, data);

        this.serializeData_delayed(this.startupState != "ready", null, 50);
    }

    private _onLoadPropertyListError(error): void {
        this.StandbyStop();
        this.handleErrorResponse(error.Message);
        //alert(error.Message);
    }

    private _onChangeOccurenceType(selectedValue: string): void {
        if (this.readonly) return;

        this.serializeData(!this.entityID);

        if (this.startupState != "loading" ) this.startupState = "ready";

        this.loadPropertyList();

        if (selectedValue == null) {
            //console.log(" selectedValue == null")
            return;
        }

        let occTypeEntity: Occurrence.OccurrenceType = this.inputOccurrenceType.getValue(true);

        if (!occTypeEntity) {
            return;
        }
        

        this.setSpecialInfoByOccurrenceType(occTypeEntity);

        if (this.entity == null) {
            this.setUrlParameter("create", selectedValue);
            let title = this.inputOccurrenceTitle.getValue();
            if (!title) {
                this.setTitles(TranslationHelpers.translate("General_New") + ( occTypeEntity ? " - " + occTypeEntity.description : ""));
            }
        }
    }

    private _onChangeCoeditors(data): void {
        //console.debug("_onChangeCoeditors", data, this.inputCoeditors.getValue());

        if (this.readonly === true) return;

        if (this.startupState == "ready" ) this.serializeData();

    }

    private _onChangeOccurenceDateTime(evt): void {
        //console.log("change datetime event");
    }

    private _onChangeOccurenceDate(evt): void {
        //console.log("change date event");
    }

    private _onChangeComment(evt): void {
        if (this.readonly === true) return;

        this.formData.comment = this.inputComment.value.trim().replace(/\s+/g, " "); //überflüssiges whitespace entfernen
        this.serializeData();
    }

    private setSpecialInfoByOccurrenceType(occTypeEntity: Occurrence.OccurrenceType): void {
        //console.log("setSpecialInfoByOccurrenceType", occTypeEntity, this.entityID);
        if (!occTypeEntity) {
            this.hideNode(this.sectionSpecialInfo);
            this.setSpecialConfirmation(null);
            this.setSpecialNote(null);
            return;
        }

        occTypeEntity.is_show_special_note == true || occTypeEntity.is_show_special_confirmation == true ? this.UiModder.domClass.remove(this.sectionSpecialInfo, "w3-hide") : this.UiModder.domClass.add(this.sectionSpecialInfo, "w3-hide");

        this.entityID != null ? this.UiModder.domClass.add(this.sectionSpecialInfo, "w3-disabled") : this.UiModder.domClass.remove(this.sectionSpecialInfo, "w3-disabled");

        this.setSpecialConfirmation(occTypeEntity.is_show_special_confirmation == true ? occTypeEntity.special_confirmation_text : "");
        this.setSpecialNote(occTypeEntity.is_show_special_note == true ? occTypeEntity.special_note : "");

    }

    private setSpecialNote(text: string): void {
        if (!text) {
            text = "";
            this.UiModder.domClass.add(this.tableSpecialNote, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.tableSpecialNote, "w3-hide");
        }

        this.UiModder.domAttr.set(this.txtSpecialNote, "innerHTML", text);
    }

    private setSpecialConfirmation(text: string): void {
        if (!text) {
            text = "";
            this.isSpecialConfirmationNeeded = false;
            this.UiModder.domClass.add(this.tableSpecialConfirmation, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.tableSpecialConfirmation, "w3-hide");
            this.isSpecialConfirmationNeeded = true;
        }

        this.setSpecialConfirmationStatus(this.entityID != null);

        this.UiModder.domAttr.set(this.txtSpecialConfirmation, "innerHTML", text);
    }

    private _onClick_SpecialConfirmation(evt): void {

        if (this.isSpecialConfirmationNeeded != true || this.readonly === true) {
            return;
        }
        this.setSpecialConfirmationStatus(this._specialConfirmationStatus !== true);
    }

    setSpecialConfirmationStatus(targetState: boolean): void {
        this._specialConfirmationStatus = targetState;

        this.serializeData();

        this.setSpecialConfirmationStatusStyle();
    }

    setSpecialConfirmationStatusStyle(): void {
        if (this.readonly === true) {
            this.UiModder.domClass.remove(this.tableSpecialConfirmation, "mds-hover-dark");
        } else {
            this.UiModder.domClass.add(this.tableSpecialConfirmation, "mds-hover-dark");
        }
        if (this._specialConfirmationStatus === true) {
            this.UiModder.domClass.add(this.buttonCheckSpecialConfirmation_Unchecked, "w3-hide");
            this.UiModder.domClass.remove(this.buttonCheckSpecialConfirmation_Checked, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.buttonCheckSpecialConfirmation_Unchecked, "w3-hide");
            this.UiModder.domClass.add(this.buttonCheckSpecialConfirmation_Checked, "w3-hide");
        }
    }
    private _lockCheckHandle: number = null;

    private _checkEntityLock() {


        if (this._lockCheckHandle) {
            try {
                clearTimeout(this._lockCheckHandle);
            } catch (ex) {

            }
        }
        this._lockCheckHandle = null;

        if (!this.entity) {
            //console.warn("tried to check entitylock without entity");
            this.removeToast("entityLocked");

            return;
        }

        //// TMP:
        //if (FeatureHelpers.hasFeature("eForms/Locking")) {
        //    this._onCheckEntityLockResult({ isLocked: false, occurrenceID: null });
        //    return;
        //}
        //this._onCheckEntityLockResult({ isLocked: false, occurrenceID: this.entity.ID });
        //return;

        let url: string = window.appRoot + "Eforms/CheckLock";

        let data = {
            "occurrenceID": this.entity.ID,
        };

        this.RequestManager.callfunction(
            "Webtool_Occurrence_API__CheckLock",
            data,
            lang.hitch(this, this._onCheckEntityLockResult),
            lang.hitch(this, this._onCheckEntityLockError)
        );
    }

    private _onClick_ReloadLockedEntity(evt: MouseEvent) {
        // wir müssen davon ausgehen, dass bei einem lock wirklich aktuell jemand am Entity arbeitet
        // also müssen etwaige Änderungen ja sowieso geladen werden
        if (this.entityID) {
            this._loadOccurrenceEntity();
        }
    }

    private _onCheckEntityLockResult(result: { "isLocked": boolean, "occurrenceID": string }) {
        if (this.entity && result.occurrenceID) {
            if (result.isLocked) {
                this.locked = true;
                this.setReadonly(true);
                this.setDirty(false);


                ToasterHelpers.showToast({
                    title:"OccurrenceFormDialog__Toast_EntityCurrentlyLocked",
                    iconClass: ToasterHelpers.ToasterIcons.info,
                    timeout: 40 * 1000,
                    showClose: false,
                    options: {
                        ID: "entityLocked",
                        hideTimeoutProgress: true,
                        buttons: [
                            {
                                callback: lang.hitch(this, this._onClick_ReloadLockedEntity),
                                icon: ToasterHelpers.ToasterIcons.redo,//"fas fa-reload",
                                label: "OccurrenceFormDialog__ToastBtn_ReloadEntityLock",
                            }
                        ]
                    }
                });
                
                if (this._lockEntityDelayedHandle) {
                    clearTimeout(this._lockEntityDelayedHandle);
                }

                this._lockCheckHandle = setTimeout(lang.hitch(this, this._checkEntityLock), 30 * 1000);
            } else {
                this.removeToast("entityLocked");

               

                // falls es davor gelockt war, ist es noch readonly.
                // etwaige Änderungen in der Zwischenzeit aufholen und das Entity frisch laden:

                if (this.locked) {

                    if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
                        this.showToast({
                            title: "Entity is not locked. Reloading after readonly...",
                            iconClass: "fas fa-lock-open w3-text-gray",
                            ID: "locking",
                            timeout: "permanent"
                        });

                        console.debug("not locked. currently readonly?", this.readonly);
                    }
                    this.locked = false;
                    this._loadOccurrenceEntity();
                    return;
                    // danach raus, weil bei der Response eh nochmal ein checkLock gemacht wird, dann kommen wir wieder hierher, aber nicht ins if
                }

                if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
                    this.showToast({
                        title: "Entity is not locked. Creating lock...",
                        iconClass: "fas fa-lock-open w3-text-gray",
                        ID: "locking",
                        timeout: "permanent"
                    });

                    console.debug("not locked. currently readonly?", this.readonly);
                }

                this._lockEntityForOthers();
                
            }
        }
    }

    private _onCheckEntityLockError(error: more.requestErrorMessage) {
        if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
            console.warn("checking entitylock failed", error.Message);

            this.showToast({
                title: "checking entitylock failed",
                iconClass: "fas fa-lock w3-text-red"
            });
        }

        this._lockCheckHandle = setTimeout(lang.hitch(this, this._checkEntityLock), 5 * 1000);
    }

    private _lockLeaseTimeSec: number = 300;
    private _lockEntityForOthers(release?: boolean, leaseTimeMinutes: number = 5) {

        if (!this.hasFeature("eForms/Locking")) {
            return;
        }
        if (!this.entity.ID) {
            console.warn("tried to lock occurrence without entity ID");
            return;
        }

        if (this._lockEntityDelayedHandle != null) clearTimeout(this._lockEntityDelayedHandle);

        this._lockEntityDelayedHandle = null;

        ////TMP:
        //this._onLockEntityResult(false, "success");
        //return;



        let url: string = window.appRoot + "Eforms/CreateLockLease";

        let data = {
            "occurrenceID": this.entity.ID,
            "bUnlock": release === true,
            "leaseTimeMinutes": Math.ceil(this._lockLeaseTimeSec / 60)
        };


        this.RequestManager.callfunction(
            "Webtool_Occurrence_API__CreateLockLease",
            data,
            lang.hitch(this, this._onLockEntityResult, release === true),
            lang.hitch(this, this._onLockEntityError, release === true),
            true
        );

        if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
            this.showToast({
                title: release ? "unlocking..." : "locking...",
                ID: "locking",
                iconClass: "fas fa-cogs"
            });
        }
    }

    private _lockEntityDelayedHandle: number = null;

    private _releaseTimeout: number;
    private _releaseLock(): void {
        this._lockEntityForOthers(true);
    }

    private _onLockEntityResult(release: boolean, result: string) {

        this.removeToast("locking");

        if (!this.hasFeature("eForms/Locking")) {
            release = true;
        }
        if (this._destroyed) return;

        if (release) {
            if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
                console.info("entity unlocked", this.entity.ID);

                this.showToast({
                    title: "entity unlocked",
                    ID: "unlocked",
                    iconClass: "fas fa-lock-open w3-text-green"
                });
            }
        } else {

            if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
                console.info("entity locked for another interval", this.entity.ID);

                this.showToast({
                    title: "entity locked for another interval",
                    ID: "lock",
                    iconClass: "fas fa-lock w3-text-red",
                    timeout: Math.ceil(this._lockLeaseTimeSec * 1000)
                });
            }

            this._lockCheckHandle = setTimeout(lang.hitch(this, this._checkEntityLock), this._lockLeaseTimeSec * 1000 - 30000);

            // wenns gelockt ist, dann das Release in einigen Minuten durchführen, falls es bis dahin kein onchanged mit dirty gab etc
            if (this._releaseTimeout) {
                clearTimeout(this._releaseTimeout);
            }
            // neues release:
            this._releaseTimeout = setTimeout(lang.hitch(this, this._releaseLock), this._lockLeaseTimeSec * 1000 + 30000);

        }

    } private _onLockEntityError(release: boolean, error: string) {
        this.removeToast("locking");
        if (this._destroyed) return;
        if (release) {
            if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {

                console.info("entity unlocking failed!", this.entity.ID);
                this.showToast({
                    title: "entity unlocking failed",
                });
            }
        } else {
            if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
                console.info("entity locking failed! retry...", this.entity.ID);

                this.showToast({
                    title: "entity locking failed! retry...", // OccurrenceFormDialog__Toast_LockingEntityFailed
                });
            }

            //this.toaster.addToast(this.translations["OccurrenceFormDialog__Toast_LockingEntityFailed"], toasterIcons.warning, { ID: "locking", timeout: 5000 });
            this._lockCheckHandle = setTimeout(lang.hitch(this, this._checkEntityLock), 5 * 1000);
        }
    }



    private setDirty(value: boolean): void {

        //console.trace("occurrenceForm setDirty (target / current / state)", value, this.isDirty, this.startupState);
        //if (this.readonly === true) return;
        if (this.readonly || this.locked) {
            this.disableButton("submit");
            this.disableButton("draft");
            return;
        }

        if (this.isDirty != value) {
            this.isDirty = value;
            this.emit("dirty", this.isDirty);

            this.enableButton("draft", this.isDirty);
        }

        let bAltEnableSubmit = false;
        if (this.isDraft) {
            bAltEnableSubmit = true;// this.checkMandatoryValues();
        }

        this.enableButton("submit", this.isDirty || bAltEnableSubmit);


        // jedes mal wenn aktiv was geändert wird: ein Lock für die nächsten 5 Minuten erzeugen
        if (this.entity) {
            // lock erneuern:
            if (!this._lockEntityDelayedHandle) {
                this._lockEntityDelayedHandle = setTimeout(lang.hitch(this, this._lockEntityForOthers), 15 * 1000);
            }
        }
    }

    private _renderPropertiesTable(propertyList: Array<Occurrence.PropertyAssignment>): void {

        //this.disableNode(this.sectionProperties, this.readonly);

        this.propertiesTable.setData(propertyList); // NEUE TABLLE 2021!!

        this.UiModder.domConstruct.empty(this.propertiesContainer);

        if (propertyList == null || typeof (propertyList) == "undefined") {
            //this.UiModder.domClass.add(this.sectionProperties, "w3-disabled");
            this.disableNode(this.sectionProperties);
            return;
        }

        this.hideNode(this.sectionProperties, false);
        this.disableNode(this.sectionProperties, false);

        this.propertiesTable.setReadOnly(this.readonly === true || this.locked === true);
    }

    private _onClickSubmitOccurrenceButton(bSaveAsDraft: boolean, dlgResult: number): void {
        if (typeof (dlgResult) != "number") dlgResult = -99; // je nach lang.hitch kann auch das clickevent daherkommen

        if (!bSaveAsDraft) {
            if (!this.checkMandatoryValues(true)) {
                this.showToast({
                    title: "OccurrenceForm__message_incompleteData",
                    iconClass: ToasterHelpers.ToasterIcons.warning,
                    ID: "saveError",
                    timeout: 7000
                });
                return;
            }
        }
        
        if (bSaveAsDraft === true) {
            this.saveOccurrenceData(bSaveAsDraft);
            return;
        } else if (dlgResult >= 2) {
            // hier kommen wir rein, wenn vorhin ein Entwurf nicht mehr als Entwurf gespeichert wurde und der Dialog ein paar Zeilen
            // drunter bestätigt
            // nix machen - einfach weiter
        } else if (dlgResult <= 0 && dlgResult > -99) {
            
            return;
        }
        else if (this.entityID && this.isDraft) {

            

            let dlg = new GenericDialog();
            dlg.setup({
                content: "OccurrenceFormDialog__SubmitDraftWarning_Message",
                header: "OccurrenceFormDialog__SubmitDraftWarning_Header",
                buttonPreset: "yesno",
                callback: lang.hitch(this, this._onClickSubmitOccurrenceButton, bSaveAsDraft),
                distinctiveNoCallback: "silentclose",
                contentIconClass: "fas fa-pencil-ruler"
            });
            
            return;

        }
        this.saveOccurrenceData(bSaveAsDraft);
    }


    private handleErrorResponse(message: string): void {
        if (typeof (this.errorCallback) == "function") {
            this.errorCallback(message);
            return;
        }

        ToasterHelpers.showToast({
            title: "General_SavingFailed",
            message: message,
            iconClass: ToasterHelpers.ToasterIcons.error
        });
        // ansonsten Fehlermeldung selber irgendwo platzieren?
        console.error(message)
    }

    private handleSuccessResponse(): void {
        if (typeof (this.successCallback) == "function") {
            this.successCallback();
            return;
        }
    }

    private _removeTimeouts() {
        if (this.entity) {
            this._lockEntityForOthers(true);
            if (this._lockCheckHandle) {
                clearTimeout(this._lockCheckHandle);
                this._lockCheckHandle = null;
            }

            if (this._releaseTimeout) clearTimeout(this._releaseTimeout);
        }

        if (this._serializeDataHandle) clearTimeout(this._serializeDataHandle);

        
        this.removeToast("entityLocked");
        this.removeToast("lock");
        this.removeToast("locking");

        this._removeTimeouts = function () { return;  }; // selber überschreiben, damits nicht mehrfach ausgeführt wird
    }

    destroy(): void {

        this._removeTimeouts();
        if (this.entityID == UrlHelpers.getUrlParameterValue("view")) {
            UrlHelpers.removeUrlParameter("view");
        }

        UrlHelpers.removeUrlParameter("ctype");
        UrlHelpers.removeUrlParameter("create");
        super.destroy.apply(this, arguments as any);
    }

}

export default mdsWidget(OccurrenceForm);